import React from "react";
import Checkbox from "@mui/material/Checkbox";
import "./styles.scss";

const CustomCheckbox = ({
  containerClassName,
  className,
  ...checkboxProps
}) => {
  return (
    <div className={`custom-checkbox-container ${containerClassName || ""}`}>
      <Checkbox
        {...checkboxProps}
        className={`custom-checkbox-style ${className || ""}`}
      />
    </div>
  );
};

export default CustomCheckbox;
